export function setCookie(name, value, days) {
	let expires = "";

	if (days) {
		const date = new Date();

		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

export function getCookie(name) {
	const nameEQ = name + "=";
	const ca = document.cookie.split(";");

	for (let i = 0; i < ca.length; i++) {
		let cb = ca[i];

		while (cb.charAt(0) === " ") cb = cb.substring(1, cb.length);
		if (cb.indexOf(nameEQ) === 0) return cb.substring(nameEQ.length, cb.length);
	}
	return null;
}
